<template>
  <div class="contact-button">
    <span
      class="cursor-pointer"
      :class="linkWrapperClasses"
      @click="showModal=true">
      <slot>
        <a
          class="flex items-center link-plain cursor-pointer">
          <feather-icon
            icon="MailIcon"
            class="mr-1"
            svgClasses="w-5 h-5"/>

          <span>
          {{ $t('$General.Contact') }}
          </span>
        </a>
      </slot>
    </span>

    <contact-modal
      v-model="showModal"/>
  </div>
</template>

<script>
import { mapState } from 'vuex';

// Components
import ContactModal from '@/layouts/components/contact/TheContactModal.vue';

/**
 * Feedback button
 *
 * @module layouts/components/TheContactButton.vue
 * @author Dilan Useche <dilan8810@gmail.com>
 *
 */
export default {
  name: 'TheContactButton',
  components: {
    ContactModal,
  },
  props: {
    linkWrapperClasses: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      showModal: false,
    };
  },
  computed: {
    ...mapState({
      contactModalKey: (state) => state.contactModalKey,
    }),
  },
  watch: {
    contactModalKey() {
      this.showModal = true;
    },
  },
};

</script>
